import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import Root from './layout/Root';
import Router from './Router';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root>
      <Router />
    </Root>
  </React.StrictMode>
);
